import React, { useMemo, useState, useEffect, useContext } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, IconButton, Grid, } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { GET_PRODUCT_WISE_EXPORT, GET_PRODUCT_WISE_IMPORT, } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import CustomLoader from "../common/CustomLoader";
import CustomReport from "../common/CustomReport";
import { genericPost } from "../../services/authServices";
import CustomDataTable from "../common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";

const title = "export product report";

const ProductWiseExportReport = () => {
    const navigate = useNavigate();
    const [permission, setPermissions] = useState()
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])


    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "productName",
                header: "Product Name",
                size: 150,
            },
            {
                accessorKey: "exportQtyByUnit",
                header: "Qty",
                size: 120,
                tableStyle: { textAlign: "center" },
            },
            {
                accessorKey: "exportQtyByPrimaryUnit",
                header: "Primary Qty",
                size: 120,
                tableStyle: { textAlign: "center" },
            },
            {
                accessorKey: "exportQtyBySecondaryUnit",
                header: "Secondary Qty",
                size: 120,
                tableStyle: { textAlign: "center" },
            },

            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                        <IconButton onClick={() => handleViewClick(row.original.productsId)}>
                            <VisibilityIcon />
                        </IconButton>
                    </div>
                ),
            },
        ],
        [permission]
    );
    const handleViewClick = (productsId) => {
        navigate(`/app/reports/productwiseexportreport/${productsId}`);
    };

    const fetchData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
            };

            const response = await genericPost(GET_PRODUCT_WISE_EXPORT, payload);

            if (response.data.success && Array.isArray(response.data.totalSummary)) {

                const mappedData = response.data.totalSummary.map((item, index) => {
                    return {
                        index: (pageIndex * pageSize + index + 1)
                            .toString()
                            .padStart(2, "0"),

                        productsId: item.productsId,
                        productName: item.productName,

                        // ✅ Already formatted from backend
                        exportQtyByUnit: item.exportQtyByUnit,
                        exportQtyByPrimaryUnit: item.exportQtyByPrimaryUnit,
                        exportQtyBySecondaryUnit: item.exportQtyBySecondaryUnit,
                    };
                });

                setData(mappedData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setError("No product report data found");
            }
        } catch (error) {
            setError("Error fetching product report data");
            console.error(error);
        } finally {
            setLoading(false);
        }
    }; useEffect(() => {
        fetchData(page, pageSize)
    }, [page, pageSize, token,])

    const defaultView = 'productwiseexportreport';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
            />
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (
        <>
            <CustomReport
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)} />
            {!permission?.view && <AccessDenied />}

        </>
    );
};
export default ProductWiseExportReport;
